import React from "react";
import "./Footer.css";
import { Col, Container, Row } from "react-bootstrap";
import bkLogo from "../../../images/bk-hossain-logo.png";

// React Icons
import { FaFacebookSquare, FaLinkedinIn, FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <Container className="footer" fluid>
        <Row className="footer-section">
          <Row className="pt-5 social-icons">
            <Col>
              <a href="https://www.facebook.com/bakhtiar.uddins/">
                <FaFacebookSquare />
              </a>
              <span className="mx-2">
                <a href="https://www.linkedin.com/in/bk-uddin/">
                  <FaLinkedinIn />
                </a>
              </span>
              <a href="https://github.com/bkuddin">
                <FaGithub />
              </a>
            </Col>
          </Row>
          <Row className="footer-text">
            <Col xs={12} sm={12} md={6}>
              <img style={{ width: "10%" }} src={bkLogo} alt="" />
              <p>
                Hey, I'm Bakhtiar Hossain Web designer and developer. I create
                custom websites to help business do better online.
              </p>
            </Col>
            <Col xs={12} sm={12} md={3}>
              <ul>
                <h5 className="title">Experiences</h5>

                <li className="list-unstyled">
                  <a href="/blog">Blog</a>
                </li>
                <li className="list-unstyled">
                  <a href="#">Sustainability</a>
                </li>
                <li className="list-unstyled">
                  <a href="#">Site Map</a>
                </li>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={3}>
              <ul>
                <h5 className="title">Legal</h5>

                <li className="list-unstyled">
                  <a href="#!">Terms of Use</a>
                </li>
                <li className="list-unstyled">
                  <a href="#!">Privacy Statement</a>
                </li>
                <li className="list-unstyled">
                  <a href="#!">To Our Customers</a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row className="copyright">
            <Col>
              &copy; {new Date().getFullYear()} Copyright:
              <a href=""> BK HOSSAIN</a>
            </Col>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
